// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-v-6a7a71e6] .v--modal .header {
  display: flex;
  padding: 15px 20px 20px 15px;
  background-color: var(--bg-color);
}
[data-v-6a7a71e6] .loader {
  position: relative;
  align-self: center;
  justify-self: center;
}
.wrapper[data-v-6a7a71e6] {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.wrapper .wrapper-item[data-v-6a7a71e6] {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.wrapper .wrapper-item .item-header[data-v-6a7a71e6] {
  display: flex;
  align-items: center;
  color: var(--main-body-color);
}
.wrapper .wrapper-item .item-header span[data-v-6a7a71e6] {
  width: 120px;
}
.wrapper .wrapper-item .item-header span.short[data-v-6a7a71e6] {
  width: 100px;
}
.wrapper .wrapper-item .item-content[data-v-6a7a71e6] {
  display: flex;
  align-items: center;
  height: 64px;
}
.wrapper .wrapper-item .item-content span[data-v-6a7a71e6] {
  width: 104px;
}
.wrapper .wrapper-item .item-content span.short[data-v-6a7a71e6] {
  width: 100px;
}
.wrapper .wrapper-item .item-content.sound-file .btn[data-v-6a7a71e6] {
  display: flex;
  align-items: center;
  border: none;
  color: var(--modal-elem-color);
  outline: 0;
  background-color: var(--bg-sound-btn);
}
.wrapper .wrapper-item .item-content.sound-file .btn[data-v-6a7a71e6]:hover {
  background-color: var(--bg-sound-btn-hover);
}
.wrapper .wrapper-item .item-content.sound-file .btn.reset i[data-v-6a7a71e6] {
  margin-left: -3px;
  margin-right: 4px;
}
.wrapper .wrapper-item .item-content.sound-file .btn i[data-v-6a7a71e6] {
  font-size: 1.8em;
  width: 0.74em;
  margin-top: 0.11em;
}
.wrapper .wrapper-item .item-content.sound-file .file-name[data-v-6a7a71e6] {
  display: flex;
  align-items: center;
  width: 200px;
  padding: 0 0.7em 0 0.66em;
  font-size: 0.88em;
  height: 42px;
  margin-top: 4px;
}
.wrapper .wrapper-item .item-content.sound-file .file-name .loader-label[data-v-6a7a71e6] {
  padding-left: 0.66em;
}
.wrapper .wrapper-item[data-v-6a7a71e6]:not(:last-child) {
  border-bottom: 1px solid var(--list-item-bordercolor);
}
.wrapper .wrapper-item.top[data-v-6a7a71e6] {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  height: 42px;
}
.wrapper .wrapper-item.top span[data-v-6a7a71e6] {
  width: 140px;
}
.wrapper .wrapper-item.no-bottom-line[data-v-6a7a71e6] {
  border-bottom: none;
}
.wrapper .wrapper-item .round-btn[data-v-6a7a71e6] {
  position: relative;
  display: inline-flex;
  width: 40px;
  min-width: 40px;
  height: 40px;
  margin-left: 4px;
  margin-right: 8px;
  background-color: #76a7f3;
  border-radius: 50%;
  cursor: pointer;
}
.wrapper .wrapper-item .round-btn i[data-v-6a7a71e6] {
  position: absolute;
  color: white;
  top: 0.6em;
  left: 0.6em;
  font-size: 1.4em;
}
.wrapper .wrapper-item .range-slider[data-v-6a7a71e6] {
  width: 100%;
  max-width: 314px;
  margin-right: 10px;
  margin-left: 12px;
  display: flex;
}
.wrapper .wrapper-item .range-slider i[data-v-6a7a71e6] {
  font-size: 16px;
  margin-top: 10px;
  margin-right: 2px;
  color: #aaa;
}
.wrapper .wrapper-item .range-slider .volume-up[data-v-6a7a71e6] {
  margin-right: -9px;
}
.wrapper .wrapper-item .range-slider .slider[data-v-6a7a71e6] {
  width: 100%;
  padding-right: 5px;
}
.wrapper .wrapper-item .range-slider[data-v-6a7a71e6] range-slider {
  display: inline-block;
  padding: 0 10px;
  height: 5px;
  width: 130px;
}
.wrapper .wrapper-item .range-slider[data-v-6a7a71e6] .range-slider.disabled {
  opacity: 0.5;
}
.wrapper .wrapper-item .range-slider[data-v-6a7a71e6] .range-slider-inner {
  display: inline-block;
  position: relative;
  height: 100%;
  width: 100%;
}
.wrapper .wrapper-item .range-slider[data-v-6a7a71e6] .range-slider-rail,
.wrapper .wrapper-item .range-slider[data-v-6a7a71e6] .range-slider-fill {
  display: block;
  position: absolute;
  top: 50%;
  left: 0;
  height: 2px;
  border-radius: 5px;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.wrapper .wrapper-item .range-slider[data-v-6a7a71e6] .range-slider-rail {
  width: 100%;
  background-color: #e2e2e2;
}
.wrapper .wrapper-item .range-slider[data-v-6a7a71e6] .range-slider-fill {
  background-color: var(--base-blue-color2);
}
.wrapper .wrapper-item .range-slider[data-v-6a7a71e6] .range-slider-knob {
  display: block;
  position: absolute;
  top: 50%;
  left: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  background-color: #aaa;
  -webkit-box-shadow: 1px 1px rgba(0, 0, 0, 0.2);
  box-shadow: 1px 1px rgba(0, 0, 0, 0.2);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  cursor: pointer;
}
.wrapper .wrapper-item .range-slider[data-v-6a7a71e6] .range-slider-knob div {
  margin-top: -22px;
  text-align: center;
}
.wrapper .wrapper-item .range-slider[data-v-6a7a71e6] .range-slider-hidden {
  display: none;
}
.wrapper .wrapper-item .range-slider[data-v-6a7a71e6] .message-btn {
  width: 34px;
  min-width: 34px;
  height: 34px;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/modal/SoundSettings.vue"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,4BAA4B;EAC5B,iCAAiC;AACnC;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,8BAA8B;EAC9B,UAAU;EACV,qCAAqC;AACvC;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qDAAqD;AACvD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;AACA;;EAEE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,WAAW;EACX,kBAAkB;EAClB,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,8BAA8B;EAC9B,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,8CAA8C;EAC9C,sCAAsC;EACtC,wCAAwC;EACxC,oCAAoC;EACpC,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,eAAe;EACf,YAAY;AACd","sourcesContent":["[data-v-6a7a71e6] .v--modal .header {\n  display: flex;\n  padding: 15px 20px 20px 15px;\n  background-color: var(--bg-color);\n}\n[data-v-6a7a71e6] .loader {\n  position: relative;\n  align-self: center;\n  justify-self: center;\n}\n.wrapper[data-v-6a7a71e6] {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n.wrapper .wrapper-item[data-v-6a7a71e6] {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.wrapper .wrapper-item .item-header[data-v-6a7a71e6] {\n  display: flex;\n  align-items: center;\n  color: var(--main-body-color);\n}\n.wrapper .wrapper-item .item-header span[data-v-6a7a71e6] {\n  width: 120px;\n}\n.wrapper .wrapper-item .item-header span.short[data-v-6a7a71e6] {\n  width: 100px;\n}\n.wrapper .wrapper-item .item-content[data-v-6a7a71e6] {\n  display: flex;\n  align-items: center;\n  height: 64px;\n}\n.wrapper .wrapper-item .item-content span[data-v-6a7a71e6] {\n  width: 104px;\n}\n.wrapper .wrapper-item .item-content span.short[data-v-6a7a71e6] {\n  width: 100px;\n}\n.wrapper .wrapper-item .item-content.sound-file .btn[data-v-6a7a71e6] {\n  display: flex;\n  align-items: center;\n  border: none;\n  color: var(--modal-elem-color);\n  outline: 0;\n  background-color: var(--bg-sound-btn);\n}\n.wrapper .wrapper-item .item-content.sound-file .btn[data-v-6a7a71e6]:hover {\n  background-color: var(--bg-sound-btn-hover);\n}\n.wrapper .wrapper-item .item-content.sound-file .btn.reset i[data-v-6a7a71e6] {\n  margin-left: -3px;\n  margin-right: 4px;\n}\n.wrapper .wrapper-item .item-content.sound-file .btn i[data-v-6a7a71e6] {\n  font-size: 1.8em;\n  width: 0.74em;\n  margin-top: 0.11em;\n}\n.wrapper .wrapper-item .item-content.sound-file .file-name[data-v-6a7a71e6] {\n  display: flex;\n  align-items: center;\n  width: 200px;\n  padding: 0 0.7em 0 0.66em;\n  font-size: 0.88em;\n  height: 42px;\n  margin-top: 4px;\n}\n.wrapper .wrapper-item .item-content.sound-file .file-name .loader-label[data-v-6a7a71e6] {\n  padding-left: 0.66em;\n}\n.wrapper .wrapper-item[data-v-6a7a71e6]:not(:last-child) {\n  border-bottom: 1px solid var(--list-item-bordercolor);\n}\n.wrapper .wrapper-item.top[data-v-6a7a71e6] {\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n  height: 42px;\n}\n.wrapper .wrapper-item.top span[data-v-6a7a71e6] {\n  width: 140px;\n}\n.wrapper .wrapper-item.no-bottom-line[data-v-6a7a71e6] {\n  border-bottom: none;\n}\n.wrapper .wrapper-item .round-btn[data-v-6a7a71e6] {\n  position: relative;\n  display: inline-flex;\n  width: 40px;\n  min-width: 40px;\n  height: 40px;\n  margin-left: 4px;\n  margin-right: 8px;\n  background-color: #76a7f3;\n  border-radius: 50%;\n  cursor: pointer;\n}\n.wrapper .wrapper-item .round-btn i[data-v-6a7a71e6] {\n  position: absolute;\n  color: white;\n  top: 0.6em;\n  left: 0.6em;\n  font-size: 1.4em;\n}\n.wrapper .wrapper-item .range-slider[data-v-6a7a71e6] {\n  width: 100%;\n  max-width: 314px;\n  margin-right: 10px;\n  margin-left: 12px;\n  display: flex;\n}\n.wrapper .wrapper-item .range-slider i[data-v-6a7a71e6] {\n  font-size: 16px;\n  margin-top: 10px;\n  margin-right: 2px;\n  color: #aaa;\n}\n.wrapper .wrapper-item .range-slider .volume-up[data-v-6a7a71e6] {\n  margin-right: -9px;\n}\n.wrapper .wrapper-item .range-slider .slider[data-v-6a7a71e6] {\n  width: 100%;\n  padding-right: 5px;\n}\n.wrapper .wrapper-item .range-slider[data-v-6a7a71e6] range-slider {\n  display: inline-block;\n  padding: 0 10px;\n  height: 5px;\n  width: 130px;\n}\n.wrapper .wrapper-item .range-slider[data-v-6a7a71e6] .range-slider.disabled {\n  opacity: 0.5;\n}\n.wrapper .wrapper-item .range-slider[data-v-6a7a71e6] .range-slider-inner {\n  display: inline-block;\n  position: relative;\n  height: 100%;\n  width: 100%;\n}\n.wrapper .wrapper-item .range-slider[data-v-6a7a71e6] .range-slider-rail,\n.wrapper .wrapper-item .range-slider[data-v-6a7a71e6] .range-slider-fill {\n  display: block;\n  position: absolute;\n  top: 50%;\n  left: 0;\n  height: 2px;\n  border-radius: 5px;\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n.wrapper .wrapper-item .range-slider[data-v-6a7a71e6] .range-slider-rail {\n  width: 100%;\n  background-color: #e2e2e2;\n}\n.wrapper .wrapper-item .range-slider[data-v-6a7a71e6] .range-slider-fill {\n  background-color: var(--base-blue-color2);\n}\n.wrapper .wrapper-item .range-slider[data-v-6a7a71e6] .range-slider-knob {\n  display: block;\n  position: absolute;\n  top: 50%;\n  left: 0;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  height: 20px;\n  width: 20px;\n  border-radius: 50%;\n  background-color: #aaa;\n  -webkit-box-shadow: 1px 1px rgba(0, 0, 0, 0.2);\n  box-shadow: 1px 1px rgba(0, 0, 0, 0.2);\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  cursor: pointer;\n}\n.wrapper .wrapper-item .range-slider[data-v-6a7a71e6] .range-slider-knob div {\n  margin-top: -22px;\n  text-align: center;\n}\n.wrapper .wrapper-item .range-slider[data-v-6a7a71e6] .range-slider-hidden {\n  display: none;\n}\n.wrapper .wrapper-item .range-slider[data-v-6a7a71e6] .message-btn {\n  width: 34px;\n  min-width: 34px;\n  height: 34px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
